import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InitialPageComponent } from './pages/initial-page/initial-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { AuthGuard } from './auth.guard';
import { CveEquipoComponent } from './components/modules/maintenance/equipment/cve-equipo/cve-equipo.component'
import { TestComponent } from './tester/test/test.component';
import { ScheduledComponent } from './components/modules/maintenance/calendar/scheduled/scheduled.component';
import { FuelOrderDetailComponent } from './components/modules/fuel/fuel-order/fuel-order-detail/fuel-order-detail.component';
import { IndicatorsFuelComponent } from './components/modules/indicators/indicators-fuel/indicators-fuel.component';
import { IndicatorsMaintenanceComponent } from './components/modules/indicators/indicators-maintenance/indicators-maintenance.component';
import { InventoryComponent } from './components/modules/inventory/inventory/inventory.component';
import { InputsDetailsComponent } from './components/modules/inventory/inputs/inputs-details/inputs-details.component';
import { OutputsDetailsComponent } from './components/modules/inventory/outputs/outputs-details/outputs-details.component';
import { UpgradePlanComponent } from './pages/upgrade-plan/upgrade-plan.component';
import { StorerRequestComponent } from './components/modules/notifications/storer-request/storer-request.component';
import { AlertComponent } from './components/modules/notifications/alert/alert.component';
import { DetailsPurchaseOrderComponent } from './components/modules/inventory/purchase-order/details-purchase-order/details-purchase-order.component';
import { AuthorizePurchaseOrderComponent } from './components/modules/notifications/authorize-purchase-order/authorize-purchase-order.component';
import { IndicatorsInventoryComponent } from './components/modules/indicators/indicators-inventory/indicators-inventory.component';
import { PermissionsComponent } from './components/modules/human-resources/permissions/permissions.component';
import { MemosComponent } from './components/modules/human-resources/memos/memos.component';
import { DisabilitiesComponent } from './components/modules/human-resources/disabilities/disabilities.component';
import { DataRoMaintenanceOrdersComponent } from './components/modules/root/data-root/data-root.component';
import { AreasComponent } from './components/modules/administration/areas/areas.component';
import { AreaDetailComponent } from './components/modules/administration/areas/area-detail/area-detail.component';
import { AdministrationDataComponent } from './components/modules/administration/administration-data/administration-data.component';
import { ProfileComponent } from './components/modules/administration/profile/profile.component';
import { ProvidersComponent } from './components/modules/administration/providers/providers.component';
import { ProvidersDetailComponent } from './components/modules/administration/providers/providers-detail/providers-detail.component';
import { UsersComponent } from './components/modules/administration/users/users.component';
import { UserDetailComponent } from './components/modules/administration/users/user-detail/user-detail.component';
import { FuelHistoryComponent } from './components/modules/fuel/fuel-history/fuel-history.component';
import { FuelOrderComponent } from './components/modules/fuel/fuel-order/fuel-order.component';
import { FuelRequestsComponent } from './components/modules/fuel/fuel-requests/fuel-requests.component';
import { AuthorizeWorkOrderComponent } from './components/modules/notifications/authorize-work-order/authorize-work-order.component';
import { MaintenanceRequestNotificationComponent } from './components/modules/notifications/maintenance-request-notification/maintenance-request-notification.component';
import { MaintenanceExecutionComponent } from './components/modules/notifications/maintenance-execution/maintenance-execution.component';
import { FuelRequestsNotificationComponent } from './components/modules/notifications/fuel-requests-notification/fuel-requests-notification.component';
import { FuelOrderNotificationComponent } from './components/modules/notifications/fuel-order-notification/fuel-order-notification.component';
import { DetailsInventoryTransferComponent } from "./components/modules/inventory/inventory-transfer/details-inventory-transfer/details-inventory-transfer.component";
import { ActivitiesComponent } from './components/modules/maintenance/activities/activities.component';
import { ActivitieDetailComponent } from './components/modules/maintenance/activities/activitie-detail/activitie-detail.component';
import { MaintenanceOrdersComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders/maintenance-orders.component';
import { MaintenaceOrderDetailComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders/maintenace-order-detail/maintenace-order-detail.component';
import { MaintenanceOrdersExecutionComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders-execution/maintenance-orders-execution.component';
import { MaintenanceOrdersDispatchComponent } from './components/modules/maintenance/maintenance-orders/maintenance-orders-dispatch/maintenance-orders-dispatch.component';
import { EquipmentComponent } from './components/modules/maintenance/equipment/equipment.component';
import { EquipmentDetailComponent } from './components/modules/maintenance/equipment/equipment-detail/equipment-detail.component';
import { MaintenanceHistoryComponent } from './components/modules/maintenance/maintenance-history/maintenance-history.component';
import { MaintenanceRegisterComponent } from './components/modules/maintenance/maintenance-register/maintenance-register.component';
import { FillInspectionComponent } from './components/modules/inspections/fill-inspection/fill-inspection.component';
import { InspectionHistoryComponent } from './components/modules/inspections/inspection-history/inspection-history.component';
import { MaintenanceRequestComponent } from './components/modules/maintenance/maintenance-request/maintenance-request.component';
import { InputsComponent } from './components/modules/inventory/inputs/inputs.component';
import { OutputsComponent } from './components/modules/inventory/outputs/outputs.component';
import { PurchaseOrderComponent } from './components/modules/inventory/purchase-order/purchase-order.component';
import { CompaniesComponent } from './components/modules/root/companies/companies.component';
import { PlansComponent } from './components/modules/root/plans/plans.component';
import { RouterComponent } from './components/modules/localization/router/router.component';
import { RouterDetailComponent } from './components/modules/localization/router/detail/router-detail.component';
import { HandlerRouterComponent } from './components/modules/localization/handler-router/handler-router.component';
import { TravelHistoryComponent } from './components/modules/localization/travel-history/travel-history.component';
import { WarehouseComponent } from './components/modules/inventory/warehouse/warehouse.component';
import { UserEntryRecordComponent } from './components/modules/human-resources/user-entry-record/user-entry-record.component';
import { RentalOrderComponent } from './components/modules/rental/rental-order/rental-order.component';
import { DetailsRentalOrderComponent } from './components/modules/rental/rental-order/details-rental-order/details-rental-order.component';
import { RentalEquipmentsComponent } from './components/modules/rental/rental-equipments/rental-equipments.component';
import { RentalIncomeDispatchComponent } from './components/modules/rental/rental-income-dispatch/rental-income-dispatch.component';
import { DevicesComponent } from './components/modules/localization/devices/devices.component';
import { QuestionsBankComponent } from './components/modules/inspections/questions-bank/questions-bank.component';
import { InspectionFormComponent } from './components/modules/inspections/inspection-form/inspection-form.component';
import { InspectionFormDetailComponent } from './components/modules/inspections/inspection-form/inspection-form-detail/inspection-form-detail.component';
import { LogsComponent } from './components/modules/root/logs/logs.component';
import { InventoryTransferComponent } from './components/modules/inventory/inventory-transfer/inventory-transfer.component';


export const routes: Routes = [
  { path: '', component: LoginPageComponent },
  { path: 'tester', component: TestComponent },
  { path: 'inicio', component: InitialPageComponent, canActivate: [AuthGuard] },
  {
    path: 'administracion',
    children: [
      {
        path: '',
        children: [
          {
            path: 'usuarios',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: UsersComponent },
              { path: 'detalle', component: UserDetailComponent },
            ],
          },
          {
            path: 'terceros',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: ProvidersComponent },
              { path: 'detalle', component: ProvidersDetailComponent },
            ],
          },
          {
            path: 'datosAdministracion',
            canActivate: [AuthGuard],
            children: [{ path: '', component: AdministrationDataComponent }],
          },
          {
            path: 'perfil',
            canActivate: [AuthGuard],
            children: [{ path: '', component: ProfileComponent }],
          },
          {
            path: 'areas',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: AreasComponent },
              { path: 'detalle', component: AreaDetailComponent },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'personal',
    children: [
      {
        path: '',
        children: [
          {
            path: 'memorandos',
            canActivate: [AuthGuard],
            children: [{ path: '', component: MemosComponent }],
          },
          {
            path: 'permisos',
            canActivate: [AuthGuard],
            children: [{ path: '', component: PermissionsComponent }],
          },
          {
            path: 'incapacidades',
            canActivate: [AuthGuard],
            children: [{ path: '', component: DisabilitiesComponent }],
          },
          {
            path: 'registro',
            canActivate: [AuthGuard],
            children: [{ path: '', component: UserEntryRecordComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'mantenimiento',
    children: [
      {
        path: '',
        children: [
          {
            path: 'equipos',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: EquipmentComponent },
              { path: 'detalle', component: EquipmentDetailComponent },
              { path: 'cve', component: CveEquipoComponent },
            ],
          },
          {
            path: 'actividades',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: ActivitiesComponent },
              { path: 'detalle', component: ActivitieDetailComponent }],
          },
          {
            path: 'calendario',
            canActivate: [AuthGuard],
            children: [{ path: '', component: ScheduledComponent }],
          },
          {
            path: 'historial',
            canActivate: [AuthGuard],
            children: [{ path: '', component: MaintenanceHistoryComponent }],
          },
          {
            path: 'orden_trabajo',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: MaintenanceOrdersComponent },
              { path: 'detalle', component: MaintenaceOrderDetailComponent },
              { path: 'autorizacion', component: AuthorizeWorkOrderComponent }
            ],
          },
          {
            path: 'ejecucion_OT',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: MaintenanceOrdersExecutionComponent },
              { path: 'detalle', component: MaintenaceOrderDetailComponent }
            ],
          },
          {
            path: 'despachar_recursos',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: MaintenanceOrdersDispatchComponent },
              { path: 'detalle', component: MaintenaceOrderDetailComponent }
            ],
          },
          {
            path: 'registro-mtto',
            canActivate: [AuthGuard],
            children: [{ path: '', component: MaintenanceRegisterComponent }],
          },
          {
            path: 'preoperacionales',

            children: [
              { path: 'formularios', canActivate: [AuthGuard], component: InspectionFormComponent },
              { path: 'detalle', component: InspectionFormDetailComponent },
              { path: 'preguntas', canActivate: [AuthGuard], component: QuestionsBankComponent },
              { path: 'diligenciar', canActivate: [AuthGuard], component: FillInspectionComponent },
              { path: 'historico', canActivate: [AuthGuard], component: InspectionHistoryComponent }
            ],
          },
          {
            path: 'solicitudes_Mtto',
            canActivate: [AuthGuard],
            children: [{ path: '', component: MaintenanceRequestComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'notificaciones',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          {
            path: 'autorizacion',
            children: [{ path: '', component: AuthorizeWorkOrderComponent }],
          },
          {
            path: 'solicitudes',
            children: [{ path: '', component: MaintenanceRequestNotificationComponent }],
          },
          {
            path: 'ejecucion',
            children: [{ path: '', component: MaintenanceExecutionComponent }],
          },
          {
            path: 'solicitudCombustible',
            children: [{ path: '', component: FuelRequestsNotificationComponent }],
          },
          {
            path: 'ordenCombustible',
            children: [{ path: '', component: FuelOrderNotificationComponent }],
          },
          {
            path: 'despacho',
            children: [{ path: '', component: StorerRequestComponent }],
          },
          {
            path: 'alertaStockMin',
            children: [{ path: '', component: AlertComponent }],
          },
          {
            path: 'orden_compra',
            children: [{ path: '', component: AuthorizePurchaseOrderComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'combustible',
    children: [
      {
        path: '',
        children: [
          {
            path: 'solicitudes_comb',
            canActivate: [AuthGuard],
            children: [{ path: '', component: FuelRequestsComponent }],
          },
          {
            path: 'historico_comb',
            canActivate: [AuthGuard],
            children: [{ path: '', component: FuelHistoryComponent }],
          },
          {
            path: 'autoriza_comb',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: FuelOrderComponent },
              { path: 'detalle', component: FuelOrderDetailComponent },],
          },
        ],
      },
    ],
  },
  {
    path: 'almacen',
    children: [
      {
        path: '',
        children: [
          {
            path: 'inventario',
            canActivate: [AuthGuard],
            children: [{ path: '', component: InventoryComponent }],
          },
          {
            path: 'entradas_inventario',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: InputsComponent },
              { path: 'detalle', component: InputsDetailsComponent },
            ],
          },
          {
            path: 'salidas_inventario',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: OutputsComponent },
              { path: 'detalle', component: OutputsDetailsComponent },
            ],
          },
          {
            path: 'orden_compra',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: PurchaseOrderComponent },
              { path: 'detalle', component: DetailsPurchaseOrderComponent },
            ],
          },
          {
            path: 'traslados-inventario',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: InventoryTransferComponent },
              { path: 'detalle', component: DetailsInventoryTransferComponent }
            ]
          },
          {
            path: 'bodegas',
            canActivate: [AuthGuard],
            children: [{ path: '', component: WarehouseComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'alquiler',
    children: [
      {
        path: '',
        children: [
          {
            path: 'catalogo',
            canActivate: [AuthGuard],
            children: [{ path: '', component: RentalEquipmentsComponent }],
          },
          {
            path: 'ingresos',
            canActivate: [AuthGuard],
            data: { isIncome: true },
            children: [
              { path: '', component: RentalIncomeDispatchComponent },
              { path: 'detalle', component: InputsDetailsComponent },
            ],
          },
          {
            path: 'despachos',
            canActivate: [AuthGuard],
            data: { isIncome: false },
            children: [
              { path: '', component: RentalIncomeDispatchComponent },
              { path: 'detalle', component: OutputsDetailsComponent },
            ],
          },
          {
            path: 'orden_alquiler',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: RentalOrderComponent },
              { path: 'detalle', component: DetailsRentalOrderComponent },
            ],
          }
        ],
      },
    ],
  },
  {
    path: 'root',
    children: [
      {
        path: '',
        children: [
          {
            path: 'companias',
            canActivate: [AuthGuard],
            children: [{ path: '', component: CompaniesComponent }],
          },
          {
            path: 'plans',
            canActivate: [AuthGuard],
            children: [{ path: '', component: PlansComponent }],
          },
          {
            path: 'data',
            canActivate: [AuthGuard],
            children: [{ path: '', component: DataRoMaintenanceOrdersComponent }],
          },
          {
            path: 'logs',
            canActivate: [AuthGuard],
            children: [{ path: '', component: LogsComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'indicators',
    children: [
      {
        path: '',
        children: [
          {
            path: 'maintenance',
            canActivate: [AuthGuard],
            children: [{ path: '', component: IndicatorsMaintenanceComponent }],
          },
          {
            path: 'fuel',
            canActivate: [AuthGuard],
            children: [{ path: '', component: IndicatorsFuelComponent }],
          },
          {
            path: 'inventory',
            canActivate: [AuthGuard],
            children: [{ path: '', component: IndicatorsInventoryComponent }],
          },
        ],
      },
    ],
  },
  {
    path: 'localization',
    children: [
      {
        path: '',
        children: [
          {
            path: 'initRouter',
            canActivate: [AuthGuard],
            children: [{ path: '', component: HandlerRouterComponent }],
          },
          {
            path: 'history',
            canActivate: [AuthGuard],
            children: [{ path: '', component: TravelHistoryComponent }],
          },
          {
            path: 'router',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: RouterComponent },
              { path: 'detalle', component: RouterDetailComponent },],
          },
          {
            path: 'devices',
            canActivate: [AuthGuard],
            children: [
              { path: '', component: DevicesComponent }]
          },
        ],
      },
    ],
  },
  {
    path: "information",
    children: [
      {
        path: '',
        component: UpgradePlanComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      errorHandler: (error) => {
        // Custom navigation error handling logic
        console.error('Navigation Error:', error);
      }
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
